<div class="w-full relative card">
  <c-input
    id="titulo-resource"
    etiqueta="Título"
    placeholder="Ingrese un título para el material"
    [(valor)]="titulo"
    [showError]="error"
    mensajeError="Falta completar el título"
  />
  <c-textarea
    id="descripcion-resource"
    etiqueta="Descripción"
    placeholder="Ingrese la descripción del material"
    [(valor)]="descripcion"
  />
  <c-dropdown
    id="capacitacion-resource"
    etiqueta="Capacitación"
    placeholder="Seleccione una capacitación a la cual pertenecerá el material"
    [(option)]="capacitacion"
    [options]="capacitaciones"
    propiedad="nombre"
  />

  <div class="hide" [ngClass]="{ show: capacitacion }">
    <div>
      <c-radio-group
        [options]="capacitacion ? capacitacion.actividades : []"
        [(option)]="actividad"
        optionLabel="nombre"
        title="Seleccione una fase, si corresponde"
        name="actividades"
      />

      <c-radio-group
        [options]="capacitacion ? capacitacion.competencia : []"
        [(option)]="competencia"
        optionLabel="nombre"
        title="Seleccione un puesto de trabajo, si corresponde"
        name="competencias"
      />
    </div>
  </div>

  <div class="hide" [ngClass]="{ show: competencia }">
    <div></div>
  </div>
  <br />
  <br />
  <p-editor
    #editor
    [(ngModel)]="text"
    [style]="{ height: '750px' }"
    id="step-1"
    [modules]="initEditor.module"
  >
    <ng-template pTemplate="header">
      <span class="ql-formats" pTooltip="Tamaño" tooltipPosition="bottom">
        <select class="ql-size" pTooltip="Tamaño" tooltipPosition="right">
          <option value="huge">Título</option>
          <option value="large">Subtítulo</option>
          <!-- Note a missing, thus falsy value, is used to reset to default -->
          <option selected>Normal</option>
          <option value="small">Pequeño</option>
        </select>
      </span>

      <span class="ql-formats">
        <button
          class="ql-bold"
          pTooltip="Negrita"
          tooltipPosition="bottom"
        ></button>
      </span>
      <span class="ql-formats">
        <button
          class="ql-italic"
          pTooltip="Cursiva"
          tooltipPosition="bottom"
        ></button>
      </span>

      <span class="ql-formats">
        <button
          class="ql-script"
          value="sub"
          pTooltip="Subtítulo"
          tooltipPosition="bottom"
        ></button>
      </span>
      <span class="ql-formats">
        <button
          class="ql-script"
          value="super"
          pTooltip="Super título"
          tooltipPosition="bottom"
        ></button>
      </span>
      <span class="ql-formats">
        <button
          value="ordered"
          aria-label="Ordered List"
          type="button"
          class="ql-list"
          aria-pressed="false"
          pTooltip="Lista ordenada"
          tooltipPosition="bottom"
        >
          <svg viewBox="0 0 18 18">
            <line class="ql-stroke" x1="7" x2="15" y1="4" y2="4"></line>
            <line class="ql-stroke" x1="7" x2="15" y1="9" y2="9"></line>
            <line class="ql-stroke" x1="7" x2="15" y1="14" y2="14"></line>
            <line
              class="ql-stroke ql-thin"
              x1="2.5"
              x2="4.5"
              y1="5.5"
              y2="5.5"
            ></line>
            <path
              class="ql-fill"
              d="M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z"
            ></path>
            <path
              class="ql-stroke ql-thin"
              d="M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156"
            ></path>
            <path
              class="ql-stroke ql-thin"
              d="M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109"
            ></path>
          </svg>
        </button>
      </span>
      <span class="ql-formats">
        <button
          value="bullet"
          aria-label="Unordered List"
          type="button"
          class="ql-list"
          aria-pressed="false"
          pTooltip="Lista"
          tooltipPosition="bottom"
        >
          <svg viewBox="0 0 18 18">
            <line class="ql-stroke" x1="6" x2="15" y1="4" y2="4"></line>
            <line class="ql-stroke" x1="6" x2="15" y1="9" y2="9"></line>
            <line class="ql-stroke" x1="6" x2="15" y1="14" y2="14"></line>
            <line class="ql-stroke" x1="3" x2="3" y1="4" y2="4"></line>
            <line class="ql-stroke" x1="3" x2="3" y1="9" y2="9"></line>
            <line class="ql-stroke" x1="3" x2="3" y1="14" y2="14"></line>
          </svg>
        </button>
      </span>

      <span class="ql-formats" pTooltip="Alineamiento" tooltipPosition="bottom">
        <select class="ql-align">
          <option selected=""></option>
          <option value="center">center</option>
          <option value="right">right</option>
          <option value="justify">justify</option>
        </select>
      </span>

      <span class="ql-formats">
        <button
          aria-label="Insert Link"
          type="button"
          class="ql-link"
          aria-pressed="false"
          pTooltip="Hipervínculo"
          tooltipPosition="bottom"
        >
          <svg viewBox="0 0 18 18">
            <line class="ql-stroke" x1="7" x2="11" y1="7" y2="11"></line>
            <path
              class="ql-even ql-stroke"
              d="M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z"
            ></path>
            <path
              class="ql-even ql-stroke"
              d="M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z"
            ></path>
          </svg>
        </button>
      </span>

      <span class="ql-formats">
        <button
          aria-label="Remove Styles"
          type="button"
          class="ql-clean"
          aria-pressed="false"
          pTooltip="Limpiar formatos"
          tooltipPosition="bottom"
        >
          <svg class="" viewBox="0 0 18 18">
            <line class="ql-stroke" x1="5" x2="13" y1="3" y2="3"></line>
            <line class="ql-stroke" x1="6" x2="9.35" y1="12" y2="3"></line>
            <line class="ql-stroke" x1="11" x2="15" y1="11" y2="15"></line>
            <line class="ql-stroke" x1="15" x2="11" y1="11" y2="15"></line>
            <rect
              class="ql-fill"
              height="1"
              rx="0.5"
              ry="0.5"
              width="7"
              x="2"
              y="14"
            ></rect>
          </svg>
        </button>
      </span>

      <span class="ql-formats group flex justify-center items-center p-0">
        <button
          id="adjuntos"
          aria-label="Insert Image"
          type="button"
          aria-pressed="false"
          pTooltip="Adjuntos"
          tooltipPosition="bottom"
          (click)="ad.open()"
        >
          <i class="pi pi-paperclip opacity-70 group-hover:opacity-100"></i>
        </button>
      </span>

      <span class="ql-formats group flex justify-center items-center p-0">
        <button
          id="videos"
          aria-label="Insert Image"
          type="button"
          aria-pressed="false"
          pTooltip="Videos"
          tooltipPosition="bottom"
          (click)="videos.open()"
        >
          <i class="pi pi-video opacity-70 group-hover:opacity-100"></i>
        </button>
      </span>
    </ng-template>
  </p-editor>
</div>

<c-modal-adjuntos #ad [editor]="editor" [adjuntos]="adjuntos" />

<c-modal-videos #videos [editor]="editor" />

<!-- Botones extras de Quill para tener en cuenta
Insertar imagen <button aria-label="Insert Image" type="button" class="ql-image" aria-pressed="false"><svg
            viewBox="0 0 18 18">
            <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect>
            <circle class="ql-fill" cx="6" cy="7" r="1"></circle>
            <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12">
            </polyline>
        </svg>
    </button>
<input type="file" accept="image/png, image/jpeg" class="ql-image"> -->
<!-- Insertar código <button aria-label="Insert Code Block" type="button" class="ql-code-block" aria-pressed="false"><svg
        viewBox="0 0 18 18">
        <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline>
        <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline>
        <line class="ql-stroke" x1="10" x2="8" y1="5" y2="13"></line>
    </svg>
</button> -->
